import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app/App.js';
import { bootstrapDemoIdentity } from './app/demoBootstrap.js';
import './styles/tokens.css';

bootstrapDemoIdentity();

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root container.');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
